import { render, staticRenderFns } from "./Mail.vue?vue&type=template&id=5e2b7464&"
import script from "./Mail.vue?vue&type=script&lang=ts&"
export * from "./Mail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports